<template>
    <div>
      <button
        style="display: none"
        type="button"
        class="btn-confirm-deactivate-member-modal"
        data-bs-toggle="modal"
        data-bs-target="#bottom_modal_confirm_deactivate_member"
      ></button>
      <div class="modal modal-bottom fade" id="bottom_modal_confirm_deactivate_member" tabindex="-1" role="dialog"
        aria-labelledby="bottom_modal_confirm_deactivate_member" style="z-index: 10000;">
        <div class="modal-dialog" role="document">
          <div class="modal-content mbr-deact">
            <div class="mbr-deact__top">
              <span class="mbr-deact__handle" aria-hidden="true"></span>
              <button type="button" class="btn-close-confirm-modal mbr-deact__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
                <i class="material-icons-round" aria-hidden="true">close</i>
              </button>
            </div>
            <div class="mbr-deact__body">
              <h5 class="mbr-deact__title">{{ $t('profile.deactivate_title') }}</h5>
              <p class="mbr-deact__sub">{{ $t('profile.deactivate_what_happens') }}</p>
              <ul class="mbr-deact__list">
                <li>{{ $t('profile.deactivate_point_voucher') }}</li>
                <li>{{ $t('profile.deactivate_point_price') }}</li>
                <li>{{ $t('profile.deactivate_point_cashback') }}</li>
              </ul>
            </div>
            <div class="mbr-deact__actions">
              <!-- keep .close-model: Profile's processSycnProfile() clicks it through jQuery -->
              <material-button size="lg" variant="outline" class="close-model" data-bs-dismiss="modal">
                {{ $t('common.no') }}
              </material-button>
              <material-button size="lg" color="danger" data-bs-dismiss="modal" @click="sycnProfile">
                {{ $t('profile.deactivate') }}
              </material-button>
            </div>
          </div>
        </div>
        <button class="btn-share-profile-modal" style="display: none" data-bs-toggle="modal"
          data-bs-target="#bottom_modal_share_profile">Success</button>
      </div>
    </div>
  </template>
  
  <script>
  import MaterialButton from "@/components/MaterialButton.vue";

  export default {
    name: "confirm-deactivate-member-modal",
    components: {
      MaterialButton,
    },
    props: {
      sycnProfile: {
        type: Function,
        default: () => { },
      },
    },
  };
  </script>
  <style scoped>
  /* Doubled with .modal.modal-bottom to outrank the square corners set below */
  .modal.modal-bottom .modal-content.mbr-deact {
    padding: 12px 24px 28px;
    background: var(--mbr-color-canvas);
    border: 0;
    border-radius: 28px 28px 0 0;
    box-shadow: var(--mbr-shadow-modal);
    font-family: var(--mbr-font-body);
  }

  .mbr-deact__top {
    position: relative;
    display: flex;
    justify-content: flex-end;
    min-height: 36px;
  }

  .mbr-deact__handle {
    position: absolute;
    top: 0;
    left: 50%;
    width: 40px;
    height: 4px;
    background: var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    transform: translateX(-50%);
  }

  .mbr-deact__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    background: var(--mbr-color-surface);
    border: 1px solid var(--mbr-color-outline);
    border-radius: var(--mbr-radius-full);
    color: var(--mbr-color-ink-headline);
  }

  .mbr-deact__close .material-icons-round {
    font-size: 20px;
  }

  .mbr-deact__body {
    padding: 4px 0 24px;
  }

  /* font-family/color set explicitly: Material Dashboard forces Roboto Slab on headings */
  .mbr-deact__title {
    margin: 0 0 6px;
    font-family: var(--mbr-font-headline) !important;
    font-size: var(--mbr-headline-md-size);
    font-weight: 800;
    line-height: var(--mbr-headline-md-line);
    letter-spacing: var(--mbr-headline-md-tracking);
    color: var(--mbr-color-ink-headline);
  }

  .mbr-deact__sub {
    margin: 0 0 16px;
    font-size: var(--mbr-body-md-size);
    font-weight: 500;
    line-height: var(--mbr-body-md-line);
    color: var(--mbr-color-ink-secondary);
  }

  .mbr-deact__list {
    margin: 0;
    padding: 14px 16px 14px 34px;
    background: var(--mbr-color-tint);
    border: 1px solid rgba(215, 194, 192, 0.6);
    border-radius: var(--mbr-radius-lg);
  }

  .mbr-deact__list li {
    font-size: var(--mbr-label-md-size);
    font-weight: 500;
    line-height: 1.6;
    color: var(--mbr-color-ink-secondary);
  }

  .mbr-deact__list li + li {
    margin-top: 6px;
  }

  .mbr-deact__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  /* Css model */
  .modal.modal-left .modal-dialog,
  .modal.modal-right .modal-dialog,
  .modal.modal-top .modal-dialog,
  .modal.modal-bottom .modal-dialog {
    -webkit-transform: translate3d(0%, 0, 0);
    -ms-transform: translate3d(0%, 0, 0);
    -o-transform: translate3d(0%, 0, 0);
    transform: translate3d(0%, 0, 0);
  }
  
  /* Left & Right */
  
  .modal.modal-left .modal-dialog,
  .modal.modal-right .modal-dialog {
    position: fixed;
    margin: auto;
    width: 500px;
    max-width: 100%;
    height: 100%;
  }
  
  .modal.modal-left .modal-content,
  .modal.modal-right .modal-content {
    height: 100%;
    overflow-y: none;
  }
  
  .modal.modal-left .modal-body,
  .modal.modal-right .modal-body {
    padding: 15px 15px 80px;
  }
  
  .modal.modal-left.fade .modal-dialog {
    left: -500px;
    -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
    -o-transition: opacity 0.3s linear, left 0.3s ease-out;
    transition: opacity 0.3s linear, left 0.3s ease-out;
  }
  
  .modal.modal-left.fade.show .modal-dialog {
    left: 0;
  }
  
  .modal.modal-right.fade .modal-dialog {
    right: -500px;
    -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
    -o-transition: opacity 0.3s linear, right 0.3s ease-out;
    transition: opacity 0.3s linear, right 0.3s ease-out;
  }
  
  .modal.modal-right.fade.show .modal-dialog {
    right: 0;
  }
  
  .modal.modal-left .modal-content,
  .modal.modal-right .modal-content,
  .modal.modal-top .modal-content,
  .modal.modal-bottom .modal-content,
  .modal.modal-full .modal-content {
    border-radius: 0;
    border: none;
  }
  
  .modal.modal-left .modal-dialog.modal-sm,
  .modal.modal-right .modal-dialog.modal-sm {
    width: 300px;
  }
  
  .modal.modal-left .modal-dialog.modal-lg,
  .modal.modal-right .modal-dialog.modal-lg {
    width: 800px;
  }
  
  .modal.modal-left .modal-dialog.modal-xl,
  .modal.modal-right .modal-dialog.modal-xl {
    width: 1140px;
  }
  
  /* Top and Bottom */
  
  .modal.modal-top .modal-dialog,
  .modal.modal-bottom .modal-dialog {
    position: fixed;
    margin: auto;
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  
  .modal.modal-top .modal-content,
  .modal.modal-bottom .modal-content {
    height: auto;
    overflow-y: none;
  }
  
  .modal.modal-top .modal-body,
  .modal.modal-bottom .modal-body {
    padding: 15px 15px;
  }
  
  /* Top */
  
  .modal.modal-top.fade .modal-dialog {
    top: -100%;
    -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
    -o-transition: opacity 0.3s linear, top 0.3s ease-out;
    transition: opacity 0.3s linear, top 0.3s ease-out;
  }
  
  .modal.modal-top.fade.show .modal-dialog {
    top: 0;
  }
  
  /* Bottom */
  
  .modal.modal-bottom.fade .modal-dialog {
    bottom: -100%;
    -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
    -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
    transition: opacity 0.3s linear, bottom 0.3s ease-out;
  }
  
  .modal.modal-bottom.fade.show .modal-dialog {
    bottom: 0;
  }
  
  .modal.modal-bottom.fade .modal-dialog {
    bottom: -100%;
  }
  
  /* Full Screen */
  
  .modal.modal-full .modal-dialog {
    position: fixed;
    margin: auto;
    width: 100%;
    max-width: 100%;
    height: 100%;
  }
  
  .modal.modal-full .modal-content {
    height: 100%;
    overflow-y: auto;
  }
  
  .modal.modal-full .close-modal {
    position: fixed;
    top: 0;
    right: 3rem;
  }
  
  /* Footer */
  
  .modal-footer-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fff;
    border-radius: 0;
  }
  
  /* XS */
  
  .modal.modal-left.xs .modal-body,
  .modal.modal-right.xs .modal-body {
    padding: 15px;
  }
  
  .btn-close {
    font-size: 25px;
    color: #222 !important;
  }
  
  .btn-close span {
    color: #222;
  }
  
  </style>
  